import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUserAccess, setTeamMemberLawyerId } from "../../redux/Apps/users/userSlice";
import { noAccessProvide } from "./AccessProvider";

const NoRoleAssignedPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const team = location.state?.team || null;

  const handleContinue = () => {
    if (team) {
      dispatch(setUserAccess(noAccessProvide));
      dispatch(setTeamMemberLawyerId(team?.lawyer?.id));
    }
    localStorage.setItem("loginAsAccessed", "true");
    navigate("/dashboard", { replace: true });
  };

  // const handleBack = () => {
  //   navigate("/login-as", { replace: true });
  // };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", p: 3 }}>
      <Box sx={{ textAlign: "center", maxWidth: 400 }}>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
          No Role Assigned
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          You don't have any role assigned yet. You can continue with limited access or wait until an administrator assigns a role.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
          <Button variant="contained" onClick={handleContinue}>
            Start Work
          </Button>
          {/*
          <Button variant="outlined" onClick={handleBack}>
            Back
          </Button>
          */}
        </Box>
      </Box>
    </Box>
  );
};

export default NoRoleAssignedPage;
